import React from 'react';

const RevertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.29426 8.76301H0.46875C0.209883 8.76301 0 8.55312 0 8.29426V0.46875C0 0.209883 0.209883 0 0.46875 0H2.34375C2.60262 0 2.8125 0.209883 2.8125 0.46875V3.52C4.60051 1.53434 7.19766 0.291797 10.085 0.312773C15.4329 0.351602 19.7118 4.67305 19.7005 10.0211C19.6891 15.3616 15.3563 19.6875 10.013 19.6875C7.50953 19.6875 5.22801 18.7378 3.50871 17.1791C3.30953 16.9986 3.30035 16.6887 3.49047 16.4986L4.8173 15.1718C4.99207 14.997 5.27285 14.9875 5.45797 15.1513C6.67031 16.2241 8.26484 16.875 10.013 16.875C13.8125 16.875 16.888 13.8002 16.888 10C16.888 6.20051 13.8132 3.125 10.013 3.125C7.72801 3.125 5.7052 4.23734 4.45543 5.95051H8.29426C8.55312 5.95051 8.76301 6.16039 8.76301 6.41926V8.29426C8.76301 8.55312 8.55312 8.76301 8.29426 8.76301Z"
      fill="#28B0E1"
    />
  </svg>
);

export default RevertIcon;
